export const COMPANY_NAME = "CAMG MANAGEMENT LLC";
export const COMPANY_SHORT = "CAMG Management";
export const COMPANY_INITIALS = "CM";
export const COMPANY_ADDRESS_FULL = "1401 21ST St Ste R, Sacramento, California, US 95811-5226";
export const COMPANY_LOCATION = "Sacramento, CA";
export const COMPANY_REGION = "Sacramento County";
export const MAP_URL = "https://www.google.com/maps/search/?api=1&query=1401%2021ST%20St%20Ste%20R%2C%20Sacramento%2C%20California%2C%20US%2095811-5226";
export const ABOUT_IMAGE_URL = "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?auto=format&fit=crop&fm=jpg&q=80&w=1600";

export const PROFILE_FACTS = [
  { "label": "Organization", "value": "CAMG MANAGEMENT LLC" },
  { "label": "Region", "value": "Sacramento County" },
  { "label": "Location", "value": "Sacramento, CA" },
];

export const PUBLIC_INFO = [
  { "label": "Organization", "value": "CAMG MANAGEMENT LLC" },
  { "label": "Area", "value": "Sacramento County, California" },
  { "label": "Address", "value": "1401 21ST St Ste R, Sacramento, California, US 95811-5226" },
];

export const CARE_PILLARS = [
  { "icon": "◐", "title": "Business profile", "body": "A concise public directory profile for CAMG Management LLC." },
  { "icon": "✦", "title": "Location details", "body": "The supplied business address is in Sacramento, California." },
  { "icon": "✿", "title": "Public information", "body": "This page presents organization and location details supplied for the profile." },
  { "icon": "❍", "title": "Visit", "body": "Use the map link to view the listed address." },
];
